import { NavLink, useLocation } from 'react-router-dom';
import cn from 'classnames';

export default function AppNavItem({
  appId,
  menuItem,
  children,
  onClick,
}: {
  appId: string;
  menuItem: string;
  children: React.ReactNode;
  onClick?: any;
}) {
  const location = useLocation();

  return (
    <div className="group inline-flex flex-col px-2">
      {onClick ? (
        <button className="inline-flex items-center py-2" onClick={onClick} type="button">
          {children}
        </button>
      ) : (
        <NavLink
          to={appId ? `/application/${appId}/${menuItem}` : '/application'}
          className="inline-flex items-center py-2"
          role="menuitem"
        >
          {children}
        </NavLink>
      )}
      <div
        className={cn('w-full h-0.5 group-hover:bg-white rounded-full', {
          'bg-white': location.pathname.endsWith(menuItem),
        })}
      />
    </div>
  );
}
